// extracted by mini-css-extract-plugin
export default {"hiddenPlacheolder":"onWPS52JQIClwBOf0tvQ","ctaText":"raNW1ULdg4n09Z0lIXBn"};